class AwePdpVariantGallery extends HTMLElement {
  connectedCallback() {
    this.thumbs = Array.from(this.querySelectorAll('.awe-pdp-variant__thumb'));
    this.images = Array.from(this.querySelectorAll('.awe-pdp-variant__image'));

    this._bindThumbs();
    this._observeImages();
    this._bindVariantUpdate();
  }

  disconnectedCallback() {
    this._observer?.disconnect();
  }

  _bindThumbs() {
    this.thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => this._scrollToImage(i));
    });
  }

  _scrollToImage(index) {
    const image = this.images[index];
    if (!image) return;
    const headerOffset = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-offset') || '0',
      10
    );
    const top = image.getBoundingClientRect().top + window.scrollY - headerOffset - 16;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  _setActive(index) {
    this.thumbs.forEach((thumb, i) => {
      thumb.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
    this.thumbs[index]?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  _observeImages() {
    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this._setActive(parseInt(entry.target.dataset.index, 10));
          }
        });
      },
      { rootMargin: '-10% 0px -80% 0px', threshold: 0 }
    );
    this.images.forEach((img) => this._observer.observe(img));
  }

  _bindVariantUpdate() {
    // Mirror what media-gallery does: listen for variant:update on the section,
    // then replace self with the freshly server-rendered gallery from the response HTML.
    const section = this.closest('.shopify-section');
    if (!section) return;

    section.addEventListener('variant:update', (event) => {
      const html = event.detail?.data?.html;
      if (!html) return;

      const newGallery = html.querySelector('awe-pdp-variant-gallery');
      if (!newGallery) return;

      // Copy over the inline style so --thumbnail-width is preserved
      newGallery.style.cssText = this.style.cssText;

      this.replaceWith(newGallery);
    });
  }
}

customElements.define('awe-pdp-variant-gallery', AwePdpVariantGallery);
